import React, { useReducer } from 'react'
import NewsContext from './newsContext'
import NewReducer from './newsReducer'
import { apiCall } from '@/product/common/api'
import { response } from '@/product/context/common'
import {
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_LATEST_NEWS,
    GET_SINGLE_LATEST_NEWS,
} from './newsTypes'

const NewsState = (props) => {
    const initialState = {
        responseStatus: null,
        latest_news: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        single_news: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
    }

    const [state, dispatch] = useReducer(NewReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getLatestNews = async (formData, from = 'news') => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getAllLatestNews', formData, '', 'latestNews'),
            ])

            if (res.data.status === 'success') {
                dispatch({
                    type: GET_LATEST_NEWS,
                    payload: {
                        records: res.data.data.responseData.records,
                        totalRecords:
                            res.data.data.responseData.records?.length,
                        setDisp: '', // or whatever value you need here
                    },
                })
            } else if (res.data.status === 'error') {
                console.warn('API error:', res.data)
                resp.commonResponse(res.data, from)
            } else {
                console.error('Unknown error structure:', res.data)
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            console.error('Catch block error:', err)
            resp.commonErrorResponse(from)
        }
    }

    const getSingleNews = async (formData, from = 'news') => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getAllLatestNews', formData, '', 'latestNews'),
            ])

            if (res.data.status === 'success') {
                dispatch({
                    type: GET_SINGLE_LATEST_NEWS,
                    payload: {
                        records: res.data.data.responseData.records,
                        totalRecords:
                            res.data.data.responseData.records?.length,
                        setDisp: '', // or whatever value you need here
                    },
                })
            } else if (res.data.status === 'error') {
                console.warn('API error:', res.data)
                resp.commonResponse(res.data, from)
            } else {
                console.error('Unknown error structure:', res.data)
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            console.error('Catch block error:', err)
            resp.commonErrorResponse(from)
        }
    }

    const submitNews = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'newsAction', formData, '', 'latestnews'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            resp.commonErrorResponse(from)
        }
    }

    const submitEndingCash = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'cashboxAction', formData, '', 'cashbox'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            resp.commonErrorResponse(from)
        }
    }

    const submitCheckDeposit = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'checkAction', formData, '', 'cashbox'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            resp.commonErrorResponse(from)
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <NewsContext.Provider
            value={{
                latest_news: state.latest_news,
                single_news: state.single_news,
                responseStatus: state.responseStatus,
                clearResponse,
                submitNews,
                submitEndingCash,
                submitCheckDeposit,
                getLatestNews,
                getSingleNews,
            }}
        >
            {props.children}
        </NewsContext.Provider>
    )
}

export default NewsState
